<template>
  <div class="delayed-details-page">
    <div class="delayed-details-title">延时费时段价格表：</div>
    <div class="small-title">免费时长(分钟):  {{delayedData.freeMinutes}}</div>
    <div class="price-table">
      <div class="price-table-row">
        <div class="price-table-th">时段</div>
        <div class="price-table-th">延时费率(元/分钟)</div>
      </div>
      <div class="price-table-row" v-for="(item,index) in delayedData.details" :key="index">
        <div class="price-table-td">{{item.beginTime}}-{{item.endTime}}</div>
        <div class="price-table-td">{{item.slotDelayPrice}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import {  getOrderDelayInfo } from "../../../common/api";
export default {
  name: 'delayed-details',
  data(){
    return{
      delayedData: {}
    }
  },
  mounted() {
    this.getOrderDelayInfo();
  },
  methods: {
    getOrderDelayInfo(){ 
      getOrderDelayInfo({delayFeePkId: this.$route.query.id,deviceType: this.$route.query.deviceType}).then((ret) => {
        if (ret.status === this.$config.ajaxStatus) {
          // 延时费信息
          let data = ret.data[0] || {};
          if(data.details){
            data.details.map(item=>{
              item.beginTime = this.$common.formatDelayTime(item.beginTime);
              item.endTime = this.$common.formatDelayTime(item.endTime);
            })
          }
          this.delayedData = data;
        }
      })
    },
  },
}
</script>
<style lang="less">
.delayed-details-page{
  min-height: 100%;
  background-color: #fff;
  padding: 0.23rem 0.2rem;
  box-sizing: border-box;
  .delayed-details-title{
    font-size: 0.36rem;
    line-height: 0.5rem;
    color: #373a44;
  }
  .small-title{
    margin-top: 0.1rem;
    font-size: 0.28rem;
    line-height: 0.4rem;
    color: #666;
  }
  .price-table{
    margin-top: 0.2rem;
    .price-table-row{
      display: flex;
      text-align: center;
    }
    .price-table-th{
      color: #333;
    }
    .price-table-td{
      color: #666;
    }
    .price-table-td,.price-table-th{
      flex: 1;
      background-color: #F8F4F5;
      font-size: 0.28rem;
      line-height: 0.4rem;
      margin-bottom: 0.02rem;
      padding: 0.1rem 0;
    }
    .price-table-td:last-child,.price-table-th:last-child{
      margin-left: 0.02rem;
    }
  }
}
</style>